import { ArchiveRemoveOutlineIcon } from './ArchiveRemoveOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 68E7CD1A-7530-4710-8A10-D9D1CF5EFB7F
 * name archive-remove-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-remove-outline.svg
 * tags
 */
export const BoxRemoveOutlineIcon = ArchiveRemoveOutlineIcon;
export default BoxRemoveOutlineIcon